import React from "react";
import styled from "styled-components";
import { BurgerIcon, CustomButton } from "@cashrent/commonground-elements";
import { DotBadge } from "../../components/top-menu/TopMenu";
import UserAvatar from "../user-avatar/UserAvatar";

const Container = styled(CustomButton)`
  padding: 0px 3px 0px 13px !important;
  border-radius: 100px !important;
  color: black !important;
  border: 1px solid #F1F1F1 !important;
`;

function BurgerAvatar(props) {
  const {
    currentUser,
    hasNotifications,
  } = props;

  return (
    <Container type="link">
      <BurgerIcon color="black" />
      <DotBadge dot={hasNotifications}>
        <UserAvatar currentUser={currentUser} size={30} />
      </DotBadge>
    </Container>
  );
}

export default BurgerAvatar;
